<div *ngFor="let emailNotification of emailNotifications; index as index" class="mt-1 card p-3">
  <!--<p>{{emailNotification|json}}</p>-->
  <form>
    <div class="form-group">
      <label for="summary">Summary</label>
      <input class="form-control" type="text" id="summary" [(ngModel)]="emailNotification.summary" name="summary">
    </div>
    <div class="form-group">
      <app-chip-input [values]="emailNotification.emails" [name]="'Emails to Notify'" [type]="'email'"></app-chip-input>
    </div>
    <div class="form-group">
      <label for="type">Notification Type</label>
      <select class="custom-select" id="type" [(ngModel)]="emailNotification.type" name="type">
        <option *ngFor="let type of types" [value]="type.value">{{type.label}}</option>
      </select>
    </div>
    <div class="form-group">
      <app-chip-select-inspector [inspectors]="emailNotification.inspectors" [name]="'Inspectors'"></app-chip-select-inspector>
    </div>
    <button class="btn btn-primary" type="button" (click)="save()">Save</button>
    <button class="btn btn-danger m-1" type="button" (click)="remove(index)">Remove</button>
  </form>
</div>
<button class="btn btn-primary mt-1" type="button" (click)="add()">Add Email Notification</button>
<!--<p>{{emailNotifications|json}}</p>-->
